import Vue from 'vue';
import Vuex from 'vuex';
import leaDataArray from '@/data/data.json';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		leaNameObj: {},
		activeLeaData: [],
		width: 0,
		yearToDisplay: 2020
	},
	getters: {
		activeLeaRecords: (state) => {
			let out = []
			try {
				out = state.activeLeaData.data.filter(arr => arr.year == state.yearToDisplay)[0].vals;
			} catch {
				out = []
			}
			return out
		},
		isMobile: (state) => {
			return state.width <= 768
		}
	},
	mutations: {
		setLeaObj: (state, leaObj) => {
			state.leaNameObj = leaObj;
		},
		setActiveLeaData: (state, data) => {
			state.activeLeaData = data;
		},
		setWidth: (state, width) => {
			state.width = width;
		}
	},
	actions: {
		setWidth: ({ commit }, width) => {
			commit('setWidth', width)
		},
		async getLeaObj({ commit }) {
			// Create LEA name mapping from the array data
			const leaMapping = {};
			leaDataArray.forEach(lea => {
				leaMapping[lea.lea_name] = lea.lea_id;
			});
			commit('setLeaObj', leaMapping);
		},
		async getActiveLea({ commit }, leaId) {
			// Find the LEA by lea_id in the array
			const data = leaDataArray.find(lea => lea.lea_id === leaId);
			
			if (data) {
				commit('setActiveLeaData', data);
			}
		}
	}
});